export let BankAccountType;

(function (BankAccountType) {
  BankAccountType["US"] = "US";
  BankAccountType["IBAN"] = "IBAN";
  BankAccountType["GB"] = "GB";
})(BankAccountType || (BankAccountType = {}));

export let PaymentsProvider;

(function (PaymentsProvider) {
  PaymentsProvider["Stripe"] = "stripe";
  PaymentsProvider["Mangopay"] = "mangopay";
  PaymentsProvider["Adyen"] = "adyen";
  PaymentsProvider["AdyenBank"] = "adyen_bank";
  PaymentsProvider["CheckoutCom"] = "checkout";
  PaymentsProvider["Payrails"] = "payrails";
  PaymentsProvider["None"] = "none";
})(PaymentsProvider || (PaymentsProvider = {}));

export let BankAccountTokenizer;

(function (BankAccountTokenizer) {
  BankAccountTokenizer["Stripe"] = "stripe";
})(BankAccountTokenizer || (BankAccountTokenizer = {}));

export let BankAccountFieldType;

(function (BankAccountFieldType) {
  BankAccountFieldType["Name"] = "name";
  BankAccountFieldType["AccountNumber"] = "account_number";
  BankAccountFieldType["RoutingNumber"] = "routing_number";
  BankAccountFieldType["SpendingType"] = "spending_type";
})(BankAccountFieldType || (BankAccountFieldType = {}));

export let BankAccountSpendingType;

(function (BankAccountSpendingType) {
  BankAccountSpendingType["Checking"] = "checking";
  BankAccountSpendingType["Savings"] = "savings";
})(BankAccountSpendingType || (BankAccountSpendingType = {}));